import {
  OPEN_SUCCESS_MODAL,
  CLOSE_SUCCESS_MODAL,
  ADD_MESSAGE_MODAL,
  ADD_TITLE_MODAL,
  ADD_TEXT_BUTTON_MODAL
} from '../actions/modalActions';

const initialState = {
  show: false,
  title: '',
  message: '',
  text_button: null
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  let newState;

  switch (type) {
    case OPEN_SUCCESS_MODAL:
      newState = { show: true };
      return { ...state, ...newState };

    case CLOSE_SUCCESS_MODAL:
      newState = { show: false };
      return { ...state, ...newState };

    case ADD_TITLE_MODAL:
      newState = { title: payload };
      return { ...state, ...newState };

    case ADD_MESSAGE_MODAL:
      newState = { message: payload };
      return { ...state, ...newState };

    case ADD_TEXT_BUTTON_MODAL:
      newState = { text_button: payload };
      return { ...state, ...newState };

    default:
      return state;
  }
} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/modalReducer.js